
import { seccionContenidoStyle } from '../styles/general';
import { inicio } from './inicio';
import { programacion } from './programacion';
import { apps_01 } from './apps_01';
import { laboral } from './laboral';

import { p01 as vivencias_dolor_p01 } from './dolor/p01';

import { articulos_informatica_01 } from './articulos_informatica_01';
import { articulos_informatica_02 } from './articulos_informatica_02';
import { terminos } from './terminos';

import React from 'react';

function baseContenido(contenido) {
    return(
        <React.Fragment>
            <div style={seccionContenidoStyle}>
                {contenido}
            </div>
            <hr/>
        </React.Fragment>
    )  
}

const conexion = {
    inicio: baseContenido(inicio),
    programacion: baseContenido(programacion),
    laboral: baseContenido(laboral),
    apps_01: baseContenido(apps_01),
    vivencias_dolor_p01: baseContenido(vivencias_dolor_p01),
    articulos_informatica_01: baseContenido(articulos_informatica_01),
    articulos_informatica_02: baseContenido(articulos_informatica_02),
    terminos: baseContenido(terminos)
};

export default conexion;
